export const emailValidation = {
	init: function(container) {
		if (!container) return;
		this.emailInput = container.querySelector('.jsEmailField input');
		if (!this.emailInput) return;
		this.emailConfirmFieldWrapper = container.querySelector('.jsEmailConfirmField');
		this.emailConfirmInput = this.emailConfirmFieldWrapper.querySelector('input');
		this.mailErrorBox = container.querySelector('.repeat-mail-error');

		this.errorDisplayCheck();
		this.assignEventListener();
	},

	assignEventListener: function() {
		this.emailConfirmInput.addEventListener('blur', ()=> {
			this.errorDisplayCheck();
		});

		this.emailInput.addEventListener('blur', ()=> {
			this.errorDisplayCheck();
		});
	},

	checkEmail: function() {
		let emailCheck = false;
		emailCheck = (this.emailInput.value === this.emailConfirmInput.value) ? true : false;
		return emailCheck;
	},

	errorDisplayCheck: function() {
		const emailValLength = (this.emailInput.value).trim().length,
			  emailConfirmValLength = (this.emailConfirmInput.value).trim().length,
			  checkIfFilled = (emailValLength === 0 || emailConfirmValLength === 0) ? false : true;

		if (!checkIfFilled) return;

		if (this.checkEmail()) {
			this.emailConfirmFieldWrapper.classList.remove('Error');
			this.mailErrorBox.classList.remove('repeat-mail-error--visible');
		} else {
			this.emailConfirmFieldWrapper.classList.add('Error');
			this.mailErrorBox.classList.add('repeat-mail-error--visible');
		}
	}
}
